<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useUserStore } from '@/entities/user/model/userStore';
import { storeToRefs } from 'pinia';
import { useVKID } from '@/features/authByVK/lib/useVKID';

const container = ref<HTMLElement | null>(null);
const userStore = useUserStore();
const { isAuth } = storeToRefs(userStore);
const { render } = useVKID();

onMounted(() => {
  userStore.initialize();
  if (!isAuth.value && container.value) {
    render(container.value);
  }
});
</script>

<template>
  <div class="popup">
    <div ref="container" />
  </div>
</template>

<style scoped>
.popup {
  transition: all 0.3s ease;
  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 0;
    right: 0;
    height: 20px;
  }
}

.popup > span {
  font-weight: 500;
  color: #2c3e50;
  padding: 0 8px;
}

.popup a {
  padding: 8px 16px;
  background: #0077ff;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  transition: background 0.2s;
  font-weight: 500;
}

.popup a:hover {
  background: #0055cc;
}

.popup button {
  padding: 8px 16px;
  background: #f1f3f5;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.popup button:hover {
  background: #e1e3e5;
}

.popup > div {
  min-width: 200px;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 768px) {
  .popup {
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
  }

  .popup > * {
    width: 100%;
    text-align: center;
  }

  .popup > div {
    min-height: 48px;
  }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.popup {
  animation: fadeIn 0.4s ease-out;
}
</style>
